import { Link } from "react-router-dom";
import { ClipboardCheck, AlertCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { displayEventTime } from "@/lib/datetime";
import type { HostingNowEvent } from "@/hooks/useHostingNow";

interface HostingNowCardProps {
  event: HostingNowEvent;
  unmarkedCount: number;
}

const HostingNowCard = ({ event, unmarkedCount }: HostingNowCardProps) => {
  const now = Date.now();
  const isPastEnd = new Date(event.end_time).getTime() < now;
  const showNudge = isPastEnd && unmarkedCount > 0;

  return (
    <div className="bg-card rounded-lg p-4 shadow-md">
      <div className="flex items-center mb-2 text-secondary">
        <ClipboardCheck className="mr-2 h-4 w-4" />
        <span className="text-xs font-semibold uppercase tracking-wide">
          You're hosting
        </span>
      </div>

      <h2 className="text-lg font-semibold text-card-foreground">
        {event.title}
      </h2>
      <p className="text-sm text-muted-foreground mt-1">
        {displayEventTime(event.start_time, event.timezone ?? undefined)}
      </p>
      {event.venue && (
        <p className="text-sm text-muted-foreground">{event.venue}</p>
      )}

      {showNudge && (
        <div className="mt-3 flex items-start gap-2 text-sm text-amber-600 dark:text-amber-400">
          <AlertCircle className="h-4 w-4 mt-0.5 shrink-0" />
          <span>
            {unmarkedCount} guest{unmarkedCount === 1 ? "" : "s"} still unmarked
            — complete check-in
          </span>
        </div>
      )}

      <div className="mt-4">
        <Link to={`/events/${event.id}/checkin`}>
          <Button className="w-full gap-2 bg-secondary text-secondary-foreground hover:bg-secondary/90">
            <ClipboardCheck className="h-4 w-4" />
            Guest list & check-in
          </Button>
        </Link>
      </div>

      <div className="mt-2 text-center">
        <Link
          to={`/events/${event.id}`}
          className="text-xs text-muted-foreground hover:text-foreground underline underline-offset-2"
        >
          View event
        </Link>
      </div>
    </div>
  );
};

export default HostingNowCard;
